<template>
	<div class="parts-locations-signature-card-edit">
		<!-- Parts Invoice Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Invoice</h4>
			</template>
			<template #content>
				<DraggableList
					title="Methods"
					subHeading="Drag & drop to order by preferred method."
				>
					<DraggableListItem
						v-for="(item, index) in localData.captureMethods"
						:key="index"
					>
						<template #content>
							<div>
								<Checkbox
									v-model="item.active"
									:labelText="item.name"
								/>
							</div>
						</template>
					</DraggableListItem>
				</DraggableList>
				<div>
					<h4>Capture Message</h4>
					<p>
						{{ localData.captureMessage }}
					</p>
				</div>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import DraggableList from '@/components/shells/draggable-list/draggable-list';
import DraggableListItem from '@/components/shells/draggable-list/draggable-list-item';
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';
import _ from 'lodash';

export default {
	name: 'PartsLocationsSignatureCardEdit',
	components: {
		SectionContainer,
		Checkbox,
		DraggableList,
		DraggableListItem
	},
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value)
		};
	},
	created() {
		// console.log('localData', this.localData);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.parts-locations-signature-card-edit {
	@include card;

	&__item {
		display: block;
	}
}
</style>
